/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Grounding_MoreInputs */

const en_us2_plan_build_grounding_more = /** @type {(inputs: Plan_Build_Grounding_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See them all in your profile`)
};

const pt_br2_plan_build_grounding_more = /** @type {(inputs: Plan_Build_Grounding_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todas no perfil`)
};

const es_419_plan_build_grounding_more = /** @type {(inputs: Plan_Build_Grounding_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verlas todas en tu perfil`)
};

const pt_pt2_plan_build_grounding_more = /** @type {(inputs: Plan_Build_Grounding_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todas no perfil`)
};

const fr_fr2_plan_build_grounding_more = /** @type {(inputs: Plan_Build_Grounding_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout voir dans ton profil`)
};

const de_de2_plan_build_grounding_more = /** @type {(inputs: Plan_Build_Grounding_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle im Profil ansehen`)
};

const it_it2_plan_build_grounding_more = /** @type {(inputs: Plan_Build_Grounding_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedile tutte nel profilo`)
};

/**
* | output |
* | --- |
* | "See them all in your profile" |
*
* @param {Plan_Build_Grounding_MoreInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_grounding_more = /** @type {((inputs?: Plan_Build_Grounding_MoreInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Grounding_MoreInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_grounding_more(inputs)
	if (locale === "es-419") return es_419_plan_build_grounding_more(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_grounding_more(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_grounding_more(inputs)
	if (locale === "de-DE") return de_de2_plan_build_grounding_more(inputs)
	if (locale === "it-IT") return it_it2_plan_build_grounding_more(inputs)
	return en_us2_plan_build_grounding_more(inputs)
});
export { plan_build_grounding_more as "plan-build.grounding_more" }